module.exports = __webpack_public_path__ + "6b4c19d193f8b4dfb41eff44c73be7b4.svg";